import { CustomFieldsFieldTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const getTaxonomyName = (taxonomyName: string) => {
  switch (taxonomyName) {
    case 'ContractType':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.contract_type')

    case 'EducationLevel':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.education_level')

    case 'ProfessionalCategory':
      return i18n.t(
        'settings.legal_entities.legal_entity.contracts.resources.professional_category'
      )

    case 'WorkingDayType':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.working_day_type')

    case 'Level':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.level')

    case 'Mutual':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.mutual')

    case 'Step':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.step')

    case 'WorkType':
      return i18n.t('settings.legal_entities.legal_entity.contracts.resources.work_type')

    case 'compensations':
      return i18n.t('settings.legal_entities.legal_entity.contracts.taxonomies.title')

    default:
      throw new Error('unexpected resource name')
  }
}

export const tagLabel = (tag: string) => {
  switch (tag) {
    case 'compensations':
      return i18n.t('company_settings.general.employment_data.contract_taxonomies.tags.default')
    default:
      return i18n.t('company_settings.general.employment_data.contract_taxonomies.tags.country')
  }
}

export const countryLabel = (country: string) => {
  switch (country) {
    case 'es':
      return i18n.t('company_settings.general.employment_data.contract_taxonomies.spain')
    case 'fr':
      return i18n.t('company_settings.general.employment_data.contract_taxonomies.france')
    case 'de':
      return i18n.t('company_settings.general.employment_data.contract_taxonomies.germany')
    case 'pt':
      return i18n.t('company_settings.general.employment_data.contract_taxonomies.portugal')
    default:
      throw new Error('unexpected resource name')
  }
}

export const getFieldsModalTitle = (type: string) => {
  switch (type) {
    case 'duplicate':
      return i18n.t('custom_fields.actions.duplicate.title')
    case 'edit':
      return i18n.t('settings.custom_fields.edit_modal.title')
    case 'delete':
      return i18n.t('custom_fields.actions.delete.title')
    default:
      return i18n.t('settings.custom_fields.new.title')
  }
}

export const getFieldsModalDescription = (type: string, label?: string) => {
  switch (type) {
    case 'duplicate':
      return i18n.t('custom_fields.actions.duplicate.description')
    case 'edit':
      return i18n.t('settings.custom_fields.edit_modal.description')
    case 'delete':
      return i18n.t('custom_fields.actions.delete.description', {
        label: label,
      })
    default:
      return i18n.t('settings.custom_fields.new.description')
  }
}

export const getFieldsModalAction = (type: string) => {
  switch (type) {
    case 'edit':
      return i18n.t('settings.custom_fields.edit_modal.submit')
    case 'delete':
      return i18n.t('custom_fields.actions.delete.confirm_delete')
    default:
      return i18n.t('custom_fields.actions.duplicate.submit')
  }
}

export const getModalIlustration = (type: string) => {
  switch (type) {
    case 'duplicate':
      return 'server-edit'
    case 'edit':
      return 'pencil'
    case 'delete':
      return 'delete'
    default:
      return 'pencil'
  }
}

export const FieldTypes: Record<string, CustomFieldsFieldTypeEnum> = {
  text: 'text',
  long_text: 'long_text',
  date: 'date',
  single_choice: 'single_choice',
  cents: 'cents',
  money: 'money',
}

export const getListIcon = (type: string) => {
  switch (type) {
    case 'text':
      return 'check'
    case 'long_text':
      return 'text-size'
    case 'date':
      return 'calendar'
    case 'single_choice':
      return 'circle'
    case 'cents':
      return 'numbers'
    default:
      return 'check'
  }
}
